import { info, banner } from '@/api/Signup'
import { subjectList } from '@/api/SignupSubject'

const state = {
  examInfo: '',
  examBannerList: [],
  subjectList: []
}

const mutations = {
  SET_EXAMINFO: (state, examInfo) => {
    state.examInfo = examInfo
  },

  SET_EXAMBANNERLIST: (state, examBannerList) => {
    state.examBannerList = examBannerList
  },

  SET_SUBJECTLIST: (state, subjectList) => {
    state.subjectList = subjectList
  }
}

const actions = {
  getSignUpInfo({ commit }, params) {
    return new Promise((resolve, reject) => {
      info(params).then(res => {
        if (res.code === 200) {
          commit('SET_EXAMINFO', res.data)
          resolve(res.data)
        }
      }).catch(error => {
        reject(error)
      })
    })
  },

  getBanner({ commit }, params) {
    return new Promise((resolve, reject) => {
      banner(params).then(res => {
        if (res.code === 200) {
          const { data } = res
          commit('SET_EXAMBANNERLIST', data)
          resolve(data)
        }
      }).catch(error => {
        reject(error)
      })
    })
  },

  getSubjectList({ commit }, params) {
    return new Promise((resolve, reject) => {
      subjectList(params).then(res => {
        if (res.code === 200) {
          const { data } = res
          commit('SET_SUBJECTLIST', data)
          resolve(data)
        }
      }).catch(error => {
        reject(error)
      })
    })
  }

}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}

